import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { Navigate } from 'react-router-dom';
import Page from '../../components/shared/Page/Page';
import Loading from '../../components/shared/Loading/Loading';
import ZapierIntegration from '../../components/integrations/ZapierIntegration/ZapierIntegration';
import { useTranslation } from '../../hooks/useTranslation';
import { DeviceWidth } from '../../interfaces/App';
import { useIntegrationsAccess } from '../../hooks/useIntegrationsAccess';

const Integrations: React.FC = () => {
  const { t } = useTranslation();
  const { canUse: canUseIntegrations, isReady: integrationsAccessReady } =
    useIntegrationsAccess();

  if (!integrationsAccessReady) {
    return <Loading />;
  }

  if (!canUseIntegrations) {
    return <Navigate to="/page-not-found" replace />;
  }

  return (
    <Page title="Elora | Integrations">
      <Stack
        direction="column"
        spacing={2}
        sx={{ width: '100%', maxWidth: DeviceWidth.LG }}
      >
        <Box>
          <h1>{t('Integrations')}</h1>
          <Typography variant="body2" color="text.secondary">
            {t(
              'Connect your favorite tools and services to automate your workflows'
            )}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: 'repeat(2, minmax(0, 1fr))',
            },
            gap: 2,
            alignItems: 'stretch',
          }}
        >
          <ZapierIntegration />
        </Box>
      </Stack>
    </Page>
  );
};

export default Integrations;
